export enum GameState {
  RoundInProgress = 0,
  ShowVotes = 1
}
